<template>
  <div>
    <el-card style="max-width:600px">
      <div slot="header" class="font-bold">系统配置</div>
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-form-item label="VIP月卡价格">
          <el-input-number v-model="form.vip_monthly_price" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="VIP季卡价格">
          <el-input-number v-model="form.vip_quarterly_price" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="VIP年卡价格">
          <el-input-number v-model="form.vip_yearly_price" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="最低提现金额">
          <el-input-number v-model="form.min_withdraw_amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="onSave">保存配置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { adminApi } from '../api';
import { vipApi } from '../api'; // getPlans is public

import request from '../api/request';

export default {
  data() {
    return {
      form: {
        vip_monthly_price: 19.90,
        vip_quarterly_price: 49.90,
        vip_yearly_price: 169.90,
        min_withdraw_amount: 10.00
      },
      saving: false
    };
  },
  async created() {
    try {
      const res = await request.get('/vip/plans');
      const plans = res.data;
      this.form.vip_monthly_price = plans.monthly ? plans.monthly.price : 19.90;
      this.form.vip_quarterly_price = plans.quarterly ? plans.quarterly.price : 49.90;
      this.form.vip_yearly_price = plans.yearly ? plans.yearly.price : 169.90;
    } catch (e) { /* use defaults */ }
  },
  methods: {
    async onSave() {
      this.saving = true;
      try {
        await adminApi.updateConfig(this.form);
        this.$message.success('配置已更新');
      } catch (e) { /* handled */ }
      finally { this.saving = false; }
    }
  }
};
</script>
